{
  "arrow-right": "Дальше",
  "arrow-left": "Назад"
}
